import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {VehicleState, DamageReport, DamageReportDocument} from '../../../models/models';
import {Translation} from '../../../models/translation';
import {DamageAdministrationService} from '../../../services/damage-administration.service';
import {LoginService} from '../../../services/login.service';
import {VehicleStateService} from '../../../services/vehiclestates.service';
import {AddressService} from '../../../services/address.service';
import {CheckService} from '../../../services/check.service';
import {UntypedFormControl} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ColumnModel, GridComponent} from '@syncfusion/ej2-angular-grids';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatLegacyCheckbox as MatCheckbox, MatLegacyCheckboxChange as MatCheckboxChange} from '@angular/material/legacy-checkbox';
import {MatDatepicker} from '@angular/material/datepicker';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import Swal from 'sweetalert2';

const moment = _moment;
export const CustomFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'DD.MM.YYYY',
    monthYearA11yLabel: 'DD.MM.YYYY',
  },
};

@Component({
  selector: 'app-damagereport',
  templateUrl: './damagereport.component.html',
  styleUrls: ['./damagereport.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MAT_DATE_FORMATS, useValue: CustomFormats
    },
    [DatePipe]
  ],
})
export class DamagereportComponent implements OnInit {
  // @ts-ignore
  @ViewChild('senderDateInput') senderDateInput: ElementRef;
  @ViewChild('damageReportGrid', {static: true}) private damageReportGrid: GridComponent;
  @ViewChild('damageReportOverviewGrid', {static: true}) private damageReportOverviewGrid: GridComponent;
  @ViewChild('damageReportClosedGrid', {static: true}) private damageReportClosedGrid: GridComponent;
  @ViewChild('fileDropRef') fileDropEl: ElementRef;
  @ViewChild('damageTypeWindow') damageTypeWindow: ElementRef;
  @ViewChild('fileUploadWindow') fileUploadWindow: ElementRef;

  public translation: Translation;
  public selectedIndex = 0;
  public damageReportOptions: ColumnModel[];
  public locale: string;
  public damageReportDataSource: VehicleState[] = [];
  public damageReportOverviewDataSource: VehicleState[] = [];
  public damageReportClosedDataSource: VehicleState[] = [];
  public typeInactive = 'true';
  public deliveryState = '';
  public damageComment = '';
  public currentCheckboxElement: MatCheckbox;
  public damageReportDocuments: DamageReportDocument[];
  public damageTypes: any = [{name: '', checked: false}, {name: '', checked: false}, {name: '', checked: false}, {
    name: '',
    checked: false
  }, {name: '', checked: false}];
  public readonly = true;
  public readonlyAll = true;
  public costEstimateFileName = '';

  public date = new UntypedFormControl(moment());
  public tempDate: Date = new Date();
  public maxDate: Date = new Date();
  public minDate: Date = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth(), this.tempDate.getDate() - 1, this.tempDate.getHours(), this.tempDate.getMinutes(), this.tempDate.getSeconds(), this.tempDate.getMilliseconds());
  public timeSelects: string[] = [];

  public damageReport = new DamageReport();

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private damageAdministrationService: DamageAdministrationService,
    private vehicleStateService: VehicleStateService,
    private addressService: AddressService,
    private datepipe: DatePipe,
  ) {
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(5);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.loadTimePicker();
    this.loadDataForGrids();
    this.initData();
  }

  public loadTimePicker() {
    const quarterHours = ['00', '15', '30', '45'];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 4; j++) {
        let time = '';
        if (i < 10) {
          time = '0' + i + ':' + quarterHours[j];
        } else {
          time = i + ':' + quarterHours[j];
        }
        this.timeSelects.push(time);
      }
      this.damageReport.DamageTime = this.timeSelects[0];
    }
  }

  public loadDataForGrids() {
    this.vehicleStateService.getVehicleStatesForDamageReportGrid(+sessionStorage.getItem('UserId')).subscribe(responseDamageReportGrid => {
      if (responseDamageReportGrid.Ok) {
        this.damageReportDataSource = responseDamageReportGrid.Obj;
        this.vehicleStateService.getVehicleStatesForDamageReportOverviewGrid(+sessionStorage.getItem('UserId')).subscribe(responseOverviewGrid => {
          if (responseOverviewGrid.Ok) {
            this.damageReportOverviewDataSource = responseOverviewGrid.Obj;
            this.vehicleStateService.getVehicleStatesForDamageReportClosedGrid(+sessionStorage.getItem('UserId')).subscribe(responseClosedGrid => {
              if (responseClosedGrid.Ok) {
                this.damageReportClosedDataSource = responseClosedGrid.Obj;
                this.initGrids();
              } else if (responseClosedGrid.Msg === 'Internal Server Error') {
                console.log(responseClosedGrid.Ex);
              }
              if (responseClosedGrid.Msg) {
                this.toast.fire({title: responseClosedGrid.Msg, icon: responseClosedGrid.Ok ? 'success' : 'error'});
              }
            }, error => {
              this.toast.fire(this.translation.InternalServerError);
            });
          } else if (responseOverviewGrid.Msg === 'Internal Server Error') {
            console.log(responseOverviewGrid.Ex);
          }
          if (responseOverviewGrid.Msg) {
            this.toast.fire({title: responseOverviewGrid.Msg, icon: responseOverviewGrid.Ok ? 'success' : 'error'});
          }
        }, error => {
          this.toast.fire(this.translation.InternalServerError);
        });
      } else if (responseDamageReportGrid.Msg === 'Internal Server Error') {
        console.log(responseDamageReportGrid.Ex);
      }
      if (responseDamageReportGrid.Msg) {
        this.toast.fire({title: responseDamageReportGrid.Msg, icon: responseDamageReportGrid.Ok ? 'success' : 'error'});
      }
    }, error => {
      this.toast.fire(this.translation.InternalServerError);
    });
  }

  public initGrids() {
    this.damageReportGrid.allowExcelExport = true;
    this.damageReportGrid.allowPaging = true;
    this.damageReportGrid.pageSettings = {pageCount: 5, pageSize: 5};
    this.damageReportGrid.toolbar = ['Search'];
    this.damageReportGrid.editSettings = {allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal'};
    this.damageReportOverviewGrid.allowExcelExport = true;
    this.damageReportOverviewGrid.allowPaging = true;
    this.damageReportOverviewGrid.pageSettings = {pageCount: 5, pageSize: 5};
    this.damageReportOverviewGrid.toolbar = ['Search'];
    this.damageReportOverviewGrid.editSettings = {allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal'};
    this.damageReportClosedGrid.allowExcelExport = true;
    this.damageReportClosedGrid.allowPaging = true;
    this.damageReportClosedGrid.pageSettings = {pageCount: 5, pageSize: 5};
    this.damageReportClosedGrid.toolbar = ['Search'];
    this.damageReportClosedGrid.editSettings = {allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal'};
    this.damageReportOptions = [
      {
        field: 'OrderId',
        headerText: this.translation.OrderNumber,
        textAlign: 'Left',
        isPrimaryKey: true,
        autoFit: true,
      },
      {
        field: 'SenderName',
        headerText: this.translation.Sender,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'SenderCity',
        headerText: this.translation.SenderCity,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'RecipientName',
        headerText: this.translation.Recipient,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'RecipientCity',
        headerText: this.translation.RecipientCity,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'EINHEIT_BEZ',
        headerText: this.translation.Model,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'ClientReference1',
        headerText: this.translation.ChassisNumber,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'ClientReference2',
        headerText: this.translation.Reference,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'ClientReference3',
        headerText: this.translation.Mark,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'DeliveryStatus',
        headerText: this.translation.Status,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'DeliveryAppointment',
        headerText: this.translation.DeliveryDate,
        textAlign: 'Left',
        autoFit: true
      }
    ];
  }

  public initData() {
    this.damageReport.DocNum = 0;
    this.damageReport.DamageDate = new Date().toLocaleDateString();
    this.damageReport.CaseEnd = '';
    this.damageReport.Reimbursement = '';
    this.damageReport.DamageTime = '12:00';
    this.damageReport.Insurance = null;
    this.damageReport.InsuranceDisplayName = '';
    this.damageReport.JobType = null;
    this.damageReport.JobTypeDisplayName = '';
    this.damageReport.CausedBy = null;
    this.damageReport.CausedByDisplayName = '';
    this.damageReport.Sender = 0;
    this.damageReport.SenderDisplayName = '';
    this.damageReport.Workshop = 0;
    this.damageReport.WorkshopDisplayName = '';
    this.damageReport.Brand = 0;
    this.damageReport.BrandDisplayName = '';
    this.damageReport.Type = 0;
    this.damageReport.TypeDisplayName = '';
    this.damageReport.Importer = null;
    this.damageReport.ImporterDisplayName = '';
    this.damageReport.Receiver = 0;
    this.damageReport.ReceiverDisplayName = '';
    this.damageReport.PolicyNo = null;
    this.damageReport.Identification = '';
    this.damageReport.License = '';
    this.damageReport.ChassisNo = '';
    this.damageReport.CostEstimate = null;
    this.damageReport.DamageAmount = null;
    this.damageReport.InsuranceAmount = null;
    this.damageReport.OwnCosts = null;
    this.damageReport.CheckDocStateDone = false;
    this.damageReport.CheckDocStateRelease = false;
    this.damageReport.CheckDocStateIncomplete = false;
    this.damageReport.InvoiceAmountLow = false;
    this.damageReport.InvoiceAmountOk = false;
    this.damageReport.InvoiceAmountHigh = false;
    this.damageReport.DriverDoor = false;
    this.damageReport.AnotherDoor = false;
    this.damageReport.Roof = false;
    this.damageReport.FrontBumper = false;
    this.damageReport.RearBumper = false;
    this.damageReport.FrontFender = false;
    this.damageReport.RearFender = false;
    this.damageReport.Bonnet = false;
    this.damageReport.RearCover = false;
    this.damageReport.Windshield = false;
    this.damageReport.RearWindow = false;
    this.damageReport.SteeringWheel = false;
    this.damageReport.Rim = false;
    this.damageReport.Tire = false;
    this.damageReport.SideMirror = false;
    this.damageReport.CarSidebar = false;
    this.damageReport.Headlights = false;
    this.damageReport.Taillight = false;
    this.damageReport.Various = false;
    this.damageReport.Underbody = false;
    this.damageReport.Comment = '';
    this.damageReport.InsuranceComment = '';
    this.damageReport.Guilty = false;
    this.damageReport.PrimaryAddressId = 0;
    this.damageReport.TransitId = null;
    this.damageReport.InsertType = true;
    this.damageReport.CreatedBy = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.damageReport.LastChangeBy = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.damageReport.DamageReportDocuments = [];
    this.deliveryState = '';
    this.resetCheckboxesFilesAndData();
  }

  openDatePicker(picker: MatDatepicker<Date>) {
    picker.open();
    setTimeout(() => this.senderDateInput.nativeElement.focus());
  }

  goBack(): void {
    this.selectedIndex = 0;
  }

  damageReportRowSelect(args: any) {
    this.initData();
    this.readonly = false;
    this.readonlyAll = false;
    this.damageReport.TransitId = args.data.OrderId;
    this.damageReport.SenderDisplayName = args.data.SenderName + ', ' + args.data.SenderCity;
    this.damageReport.ReceiverDisplayName = args.data.RecipientName + ', ' + args.data.RecipientCity;
    this.damageReport.TypeDisplayName = args.data.ModelName;
    this.damageReport.Identification = args.data.ClientReference2;
    this.damageReport.ChassisNo = args.data.ClientReference1;
    this.damageReport.License = args.data.ClientReference3;
    this.deliveryState = args.data.DeliveryStatus + ' - ' + args.data.DeliveryAppointment;
    this.selectedIndex = 1;
  }

  damageReportOverviewRowSelect(args: any) {
    this.readonly = true;
    this.readonlyAll = false;
    this.resetCheckboxesFilesAndData();
    this.damageAdministrationService.getDamageReportByTransitId(args.data.OrderId).subscribe((damageReport: DamageReport) => {
      this.damageReport = damageReport;
      this.damageReport.SenderDisplayName = args.data.SenderName + ', ' + args.data.SenderCity;
      this.damageReport.ReceiverDisplayName = args.data.RecipientName + ', ' + args.data.RecipientCity;
      this.damageReport.TypeDisplayName = args.data.ModelName;
      this.damageReport.DamageReportDocuments.forEach(drd => {
        drd.Progress = 100;
        drd.Size = (drd.Base64String.toString().length * (3 / 4)) - (drd.Base64String.toString().endsWith('==') ? 2 : 1);
      });
      this.deliveryState = args.data.DeliveryStatus + ' - ' + args.data.DeliveryAppointment;
      this.selectedIndex = 1;
    });
  }

  damageReportClosedRowSelect(args: any) {
    this.readonly = true;
    this.readonlyAll = true;
    this.resetCheckboxesFilesAndData();
    this.damageAdministrationService.getDamageReportByTransitId(args.data.OrderId).subscribe((damageReport: DamageReport) => {
      this.damageReport = damageReport;
      this.damageReport.SenderDisplayName = args.data.SenderName + ', ' + args.data.SenderCity;
      this.damageReport.ReceiverDisplayName = args.data.RecipientName + ', ' + args.data.RecipientCity;
      this.damageReport.TypeDisplayName = args.data.ModelName;
      this.damageReport.DamageReportDocuments.forEach(drd => {
        drd.Progress = 100;
        drd.Size = (drd.Base64String.toString().length * (3 / 4)) - (drd.Base64String.toString().endsWith('==') ? 2 : 1);
      });
      this.deliveryState = args.data.DeliveryStatus + ' - ' + args.data.DeliveryAppointment;
      this.selectedIndex = 1;
    });
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  documentDoubleClick(file: DamageReportDocument) {
    const fileType = file.FileName.split('.');
    const binaryString = window.atob(file.Base64String.toString());
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    let blob = new Blob();
    switch (fileType[fileType.length - 1].toLowerCase()) {
      case 'pdf':
        blob = new Blob([bytes], {type: 'application/pdf'});
        break;
      case 'doc':
      case 'docx':
        blob = new Blob([bytes], {type: 'application/msword'});
        break;
      case 'xls':
      case 'xlsx':
        blob = new Blob([bytes], {type: 'application/vnd.ms-excel'});
        break;
      case 'png':
        blob = new Blob([bytes], {type: 'image/png'});
        break;
      case 'jpg':
        blob = new Blob([bytes], {type: 'image/jpg'});
        break;
      case 'jpeg':
        blob = new Blob([bytes], {type: 'image/jpeg'});
        break;
      case 'msg':
        blob = new Blob([bytes], {type: 'application/outlook'});
        break;
      default:
        Swal.fire(this.translation.Error, this.translation.DataFormatNotSupported, 'error');
        return;
    }
    const fileURL = URL.createObjectURL(blob);
    if (fileType[fileType.length - 1].toLowerCase() === 'msg') {
      const downloadLink = document.createElement('a');
      downloadLink.href = fileURL;
      downloadLink.setAttribute('download', file.FileName);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      return;
    }
    window.open(fileURL, '_blank');
  }

  prepareSend() {
    if (!this.readonly) {
      Swal.fire({
        title: this.translation.AreYouSure + '...?',
        text: '...' + this.translation.AreYouSurePart2,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#CC0000',
        cancelButtonColor: '#CC0000',
        confirmButtonText: this.translation.Yes,
        cancelButtonText: this.translation.No,
      }).then((result) => {
        if (result.isConfirmed) {
          this.send();
        } else {
          Swal.fire(this.translation.Information, this.translation.NoIamNot, 'info');
        }
      });
    } else {
      this.send();
    }
  }

  async send() {
    this.damageReport.UserId = +sessionStorage.getItem('UserId');
    this.damageReport.LastChangeBy = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.damageReport.InsertType = true;
    if (!this.readonly) {
      this.damageReport.DamageDate = this.datepipe.transform(this.tempDate, 'dd.MM.yyyy');
    }
    if (this.damageReport.DamageReportDocuments.length === 0) {
      Swal.fire(this.translation.Error, this.translation.YouMustSelectAtLeastOneDamage, 'error');
    } else {
      if (this.damageReport.DocNum === 0) {
        await new Promise(f => setTimeout(f, 2000));
        this.damageAdministrationService.insertDamageReport(this.damageReport).subscribe((damageReport: DamageReport) => {
          if (damageReport != null) {
            if (this.damageReport.CostEstimate === 0) {
              Swal.fire(this.translation.Success, this.translation.DamageReportSuccessWithInfoMessage, 'info');
            } else {
              Swal.fire(this.translation.Success, this.translation.DamageReportSuccessMessage, 'success');
            }
          } else {
            Swal.fire(this.translation.Error, this.translation.DamageReportErrorMessage, 'error');
          }
          this.loadDataForGrids();
          this.initData();
          this.goBack();
        });
      } else {
        this.damageAdministrationService.updateDamageReport(this.damageReport).subscribe((damageReport: DamageReport) => {
          if (damageReport != null) {
            Swal.fire(this.translation.Success, this.translation.YourChangesWereSuccessfullySaved, 'success');
          } else {
            Swal.fire(this.translation.Error, this.translation.ProblemWhileSavingChanges, 'error');
          }
          this.loadDataForGrids();
          this.initData();
          this.goBack();
        });
      }
    }
  }

  goToNextStep() {
    if (this.damageTypes[4].checked && this.damageComment === '') {
      Swal.fire(this.translation.Error, this.translation.PleaseAddAComment, 'error');
    } else if (this.damageTypes.filter(o => o.checked).length === 0) {
      Swal.fire(this.translation.Error, this.translation.PleaseSelectADamageType, 'error');
    } else {
      this.damageTypeWindow.nativeElement.setAttribute('style', 'display: none;');
      this.fileUploadWindow.nativeElement.setAttribute('style', 'display: flex;');
    }
  }

  onFileDropped(event) {
    this.getFiles(event, true);
  }

  getFiles(event, dropped) {
    let amountOfSelectedDamages = 0;
    let damageType2Text = '';
    this.damageTypes.forEach(o => {
      if (o.checked) {
        damageType2Text += o.name + ', ';
        amountOfSelectedDamages += 1;
      }
    });
    if (!dropped) {
      Array.prototype.forEach.call(event.target.files, (file) => {
        if ((amountOfSelectedDamages * 2) < event.target.files.length) {
          Swal.fire(this.translation.Error, this.translation.YouSelectedTooManyFiles, 'error');
          return;
        }
        const damageReportDocument = new DamageReportDocument();
        damageReportDocument.DamageReportDocumentId = 0;
        damageReportDocument.FileName = file.name;
        damageReportDocument.DamageType1 = this.currentCheckboxElement.name;
        damageReportDocument.DamageType2 = damageType2Text.substr(0, damageType2Text.length - 2);
        damageReportDocument.Progress = 100;
        damageReportDocument.ReportId = this.damageReport.DocNum;
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => {
          damageReportDocument.Base64String = btoa(reader.result.toString());
          damageReportDocument.Size = (damageReportDocument.Base64String.toString().length * (3 / 4)) - (damageReportDocument.Base64String.toString().endsWith('==') ? 2 : 1);
          this.damageReportDocuments.push(damageReportDocument);
        };
      });
    } else {
      Array.prototype.forEach.call(event, (file) => {
        if ((amountOfSelectedDamages * 2) < event.length) {
          Swal.fire(this.translation.Error, this.translation.YouSelectedTooManyFiles, 'error');
          return;
        }
        const damageReportDocument = new DamageReportDocument();
        damageReportDocument.DamageReportDocumentId = 0;
        damageReportDocument.FileName = file.name;
        damageReportDocument.DamageType1 = this.currentCheckboxElement.name;
        damageReportDocument.DamageType2 = damageType2Text.substr(0, damageType2Text.length - 2);
        damageReportDocument.Progress = 100;
        damageReportDocument.ReportId = this.damageReport.DocNum;
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => {
          damageReportDocument.Base64String = btoa(reader.result.toString());
          damageReportDocument.Size = (damageReportDocument.Base64String.toString().length * (3 / 4)) - (damageReportDocument.Base64String.toString().endsWith('==') ? 2 : 1);
          this.damageReportDocuments.push(damageReportDocument);
        };
      });
    }
  }

  deleteFile(index: number) {
    this.damageReportDocuments.splice(index, 1);
  }

  checkBoxChangeEvent(event: MatCheckboxChange) {
    this.currentCheckboxElement = event.source;
    if (event.checked) {
      window.scrollTo(0, 0);
      this.damageTypeWindow.nativeElement.setAttribute('style', 'display: flex;');
    } else {
      this.damageReport.DamageReportDocuments = this.damageReport.DamageReportDocuments.filter(o => o.DamageType1 !== event.source.name);
      this.resetCheckboxesFilesAndData();
    }
  }

  saveAll() {
    if (this.damageReportDocuments.length < this.damageTypes.filter(o => o.checked).length) {
      Swal.fire(this.translation.Error, this.translation.YouMustUploadAtLeastOneFotoForEachSelectedDamageType, 'error');
    } else if (this.damageReportDocuments.length > (this.damageTypes.filter(o => o.checked).length * 2)) {
      Swal.fire(this.translation.Error, this.translation.YouCannotUploadMoreThanTwoFotoEachDamageType, 'error');
    } else {
      this.damageReportDocuments.forEach(doc => {
        doc.DamageComment = this.damageComment;
        this.damageReport.DamageReportDocuments.push(doc);
      });
      this.fileUploadWindow.nativeElement.setAttribute('style', 'display: none;');
      this.resetCheckboxesFilesAndData();
    }
  }

  dismissAll() {
    this.currentCheckboxElement.checked = false;
    this.resetCheckboxesFilesAndData();
    this.damageTypeWindow.nativeElement.setAttribute('style', 'display: none;');
    this.fileUploadWindow.nativeElement.setAttribute('style', 'display: none;');
  }

  resetCheckboxesFilesAndData() {
    this.damageReportDocuments = [];
    this.damageComment = '';
    this.currentCheckboxElement = null;
    this.damageTypes = [{name: this.translation.Scratch, checked: false}, {
      name: this.translation.Bump,
      checked: false
    }, {name: this.translation.GlassDamage, checked: false}, {name: this.translation.FactoryDamage, checked: false}, {
      name: this.translation.Others,
      checked: false
    }];
    try {
      this.fileDropEl.nativeElement.value = '';
    } catch {
    }
  }

  changeDamageTypeCheckBoxEvent(event: MatCheckboxChange) {
    this.damageTypes[this.damageTypes.findIndex(o => o.name === event.source.name)].checked = event.checked;
  }

  uploadCostEstimateFile(files) {
    try {
      const damageReportDocument = new DamageReportDocument();
      damageReportDocument.DamageReportDocumentId = 0;
      damageReportDocument.FileName = files[0].name;
      damageReportDocument.DamageType1 = this.translation.CostEstimate;
      damageReportDocument.DamageType2 = '';
      damageReportDocument.Progress = 100;
      damageReportDocument.ReportId = this.damageReport.DocNum;
      const reader = new FileReader();
      reader.readAsBinaryString(files[0]);
      reader.onload = () => {
        damageReportDocument.Base64String = btoa(reader.result.toString());
        damageReportDocument.Size = (damageReportDocument.Base64String.toString().length * (3 / 4)) - (damageReportDocument.Base64String.toString().endsWith('==') ? 2 : 1);
        this.damageReport.DamageReportDocuments.push(damageReportDocument);
      };
      Swal.fire(this.translation.Success, this.translation.FileSuccessfullyUploaded, 'success');
    } catch {
      Swal.fire(this.translation.Error, this.translation.FileNotUploaded, 'error');
    }
  }
}
